query MyTransactionStatusChartData {
  kpiMyTransactionStatuses(orderBy: ID_ASC) {
    nodes {
      title
      amount
      searchHint
    }
  }
}
